import React from "react"
import './KiCards.scss'
import kiImage from '../../../assets/images/lovdata-ki-sok.png'
import Animation from '../../ClientCase/Animation/Animation'
import tommyImg from '../../../assets/images/tommy.png'
import { Link } from "gatsby"

const content = {
	"title": "Fordelene med KI-søk i Lovdata Pro 2",
	"cards": [
		{
			"title": "🔍 Presise og relevante treff",
			"text": "Søketreff basert på innhold og sammenheng, ikke bare søkeord."
		},
		{
			"title": "🚀 Effektiv veiledning",
			"text": "Du får fortsatt oversikt over rettskildene, men nå med forklaringer og sammenstillinger."
		},
		{
			"title": "📚 Juridisk kvalitet i bunn",
			"text": "Alt er forankret i autentiske, autoritative kilder."
		},
		{
			"title": "🤝 Trygghet i komplekse spørsmål",
			"text": "Løsningen hjelper deg å avklare og utdype problemstillingen din."
		}
	],
	"subTitle": "Lovdatas KI-søk er ikke bare et nytt verktøy – det er en ny standard.",
	"text": "Vi kombinerer teknologi og tillit, og gir deg trygghet i møte med juridisk problemløsning."
}

export default function KiCards() {

	const { title, cards, subTitle, text } = content

	return(
		<>
			<div className="KiCards">
				<div className="wrapper">
					<h2>{title}</h2>
					<div className="cards">
						{cards.map((card, index) => (
							<div key={index} className="card">
								<h3>{card.title}</h3>
								<p>{card.text}</p>
							</div>
						))}
					</div>
				</div>
			</div>
			<div className="getStarted">
				<div className="wrapper">
					<div className="image">
						<img src={tommyImg} alt="Bilde av Tommy Karwe Nilsen, salgskonsulent i Lovdata" />
					</div>
					<div className="text">
						<h2>Prøv Lovdata Pro 2 med KI til halve prisen ut året!</h2>
						<p>Med Lovdata Pro 2 kan du finne rettskilder med helt naturlig språk og «sparre» deg videre ned i sammenstillingen. Vi gir nye kunder 50% rabatt ut året så dere kan finne ut om det er nyttig for deres behov.</p>
						<Link to="/prov-gratis" className="button">Kom i gang her</Link>
					</div>
				</div>
			</div>
			<div className="howItWorks">
				<div className="wrapper">
					<div className="text">
						<p className="lead">{subTitle}</p>
						<p className="paragraph">{text}</p>
					</div>
					<img className="kiImage" src={kiImage} alt="En illustrasjon som viser hvordan KI søket i Lovdata Pro 2 fungerer." />
				</div>
			</div>
			<div className="logoReveal">
				<div className="wrapper">
						<div className="logo">
							<Animation animationname="lovdataLogo" />
						</div>
						<div className="text">
							<p className="lead">Lovdata Pro 2 åpner døren for ny teknologi og nye funksjoner.</p>
							<p className="paragraph">Den bringer med seg ny standard for brukervennlighet, universell utforming og en forbedret struktur av rettskildene.</p>
						</div>
				</div>
			</div>
		</>
	)
}